// extracted by mini-css-extract-plugin
export var image = "_ih-0";